import { render, staticRenderFns } from "./SynopsisResults.vue?vue&type=template&id=085fa9e6"
import script from "./SynopsisResults.vue?vue&type=script&lang=js"
export * from "./SynopsisResults.vue?vue&type=script&lang=js"
import style0 from "./SynopsisResults.vue?vue&type=style&index=0&id=085fa9e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports